import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {ChallengeBuilderProject, ChallengeMetric} from 'src/app/core/model/project';
import {CbTargetDisplayPipe} from 'src/app/shared/pipes/challenge-target-display.pipe';

@Component({
  selector: 'cb-outline',
  standalone: true,
  imports: [CommonModule, CbTargetDisplayPipe],
  templateUrl: './cb-outline.component.html',
  styleUrl: './cb-outline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbOutlineComponent {
  cbProject = input<ChallengeBuilderProject>();

  initialGoal = computed(() => this.cbProject()?.challengeBuilder?.initialGoal || '');

  selectedGoal = computed(() => {
    const goals = this.cbProject()?.challengeBuilder?.goals || [];
    return goals.find(g => g.selected);
  });

  selectedObjectives = computed(() => {
    const objectives = this.cbProject()?.challengeBuilder?.objectives || [];
    return objectives.filter(o => o.selected);
  });

  selectedTasks = computed(() => {
    const tasks = this.cbProject()?.challengeBuilder?.tasks || [];
    return tasks.filter(t => t.selected);
  });

  metrics = computed(() => this.cbProject()?.challengeBuilder?.metrics || []);

  metricsWithTargets = computed(() => {
    const objectives = this.cbProject()?.challengeBuilder?.objectives || [];
    const allWithTargets: ChallengeMetric[] = objectives.flatMap(obj =>
      (obj.tasks || []).flatMap(task => (task.metrics || []).filter(m => m.target))
    );
    return allWithTargets;
  });

  scheduledTasks = computed(() => {
    const tasks = this.cbProject()?.challengeBuilder?.tasks || [];
    return tasks.filter(t => t.schedule?.length);
  });

  getMetricIcon(metric: ChallengeMetric): string {
    return `assets/img/icons/challenge-builder/${metric.type}.svg`;
  }
}
